import angular from 'angular';
import leadAllocationCount from './leadAllocationCount';
import './style.scss';

export default angular
  .module('components.leadAllocationCount', [])
  .component('leadAllocationCount', leadAllocationCount).name;
